import React, { useState } from "react";
import "./LoyaltyCardDetails.css"; // <-- import the css file

function LoyaltyCardDetails() {
  const [form, setForm] = useState({
    name: "",
    car: "",
    phone: ""
  });

  // handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Example API call
    const response = await fetch("https://your-api.com/loyalty", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    const data = await response.json();
    console.log("Response:", data);
    alert("Form submitted successfully!");
  };

  return (
    <div className="loyalty-page">
      <div className="loyalty-form-box">
        <h2>Loyalty Card Details</h2>
        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <label>Car</label>
          <input
            type="text"
            name="car"
            value={form.car}
            onChange={handleChange}
            required
          />

          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
          />

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default LoyaltyCardDetails;
